import i from "./_memoizeCapped.js";
var m = i, u = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, c = /\\(\\)?/g, d = m(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(u, function(a, p, o, t) {
    r.push(o ? t.replace(c, "$1") : p || a);
  }), r;
}), n = d;
export {
  n as default
};
//# sourceMappingURL=_stringToPath.js.map
